<template>
  <div class="container">
    <el-container>
      <el-aside width="200px">
        <!-- <div v-for="item in list" :key="item.name" @click="menuClick(item)">{{ item.name }}</div> -->
        <el-menu style="height:100%" background-color="#545c64" text-color="#ffffff" active-text-color="#ffd04b">
          <el-menu-item :index="index"  v-for="(item,index) of list" :key="index" @click="menuClick(item)">{{ item.name }}</el-menu-item>

        </el-menu>

      </el-aside>
      <el-card shadow="always" :body-style="{ padding: '20px' }">

        <div style="width:800px">
          <pdf :src="src"></pdf>
        </div>
      </el-card>

    </el-container>

  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {

  data() {
    return {
      src: 'https://kmzhtc-app.oss-cn-shenzhen.aliyuncs.com/yzparking-announcement/inspect.pdf',
      list: [
        {
          url: "https://kmzhtc-app.oss-cn-shenzhen.aliyuncs.com/yzparking-announcement/inspect.pdf",
          name: "拟考察人员公示 "
        },
        {
          url: "https://kmzhtc-app.oss-cn-shenzhen.aliyuncs.com/yzparking-announcement/Hired.pdf",
          name: "拟录用人员公示"
        }
      ]
    }
  },
  components: { pdf },
  mounted() {

  },
  methods: {
    menuClick(item) {
      this.src = item.url
    }
  },
}

</script>
<style scoped  >
.container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/announcement.vue